import React from 'react';
import { Pagination } from 'react-admin';

const CustomPagination = props => <Pagination rowsPerPageOptions={[20, 30, 50]} {...props} />;

export default CustomPagination;
